import { h } from '@stencil/core';

import { FluidI18nStore } from '../../../providers/fluid-i18n-provider/store/fluid-i18n.store';

/**
 * @TODO - Move to core (Upcoming PR with documentation to move all translation options to Core)
 */
export interface FluidFormLabelTranslationOptions {
  label?: string;
  supplementaryLabel?: string;
}

/**
 * Renders the form label text, with translations where applicable
 */
interface FormLabelTextProps {
  label?: string;
  i18nStore?: FluidI18nStore;
  fluidTranslate?: FluidFormLabelTranslationOptions;
  setRef: (el: HTMLElement) => void;
}
export const FormLabelText = (props: FormLabelTextProps) => {
  const { label, i18nStore, fluidTranslate, setRef } = props;
  return (
    <span class='fluid-label-text' ref={(el: HTMLElement) => setRef(el)}>
      {i18nStore?.translate(fluidTranslate?.label) || label}
    </span>
  );
};

/**
 * Renders the form label supplementary text, with translations where applicable
 */
interface SupplementaryLabelProps {
  supplementaryLabel?: string;
  i18nStore?: FluidI18nStore;
  fluidTranslate?: FluidFormLabelTranslationOptions;
}
export const SupplementaryLabel = (props: SupplementaryLabelProps) => {
  const { supplementaryLabel, i18nStore, fluidTranslate } = props;
  const labelText =
    i18nStore?.translate(fluidTranslate?.supplementaryLabel) ||
    supplementaryLabel;
  return !!labelText && <span class='supplementary'>{labelText}</span>;
};
